<template>
  <div id="stop-menu-bottom">

    <div class="row stop-menu-row">
      <h5 class="stop-menu-bottom-heading">
        其他路線
      </h5>
      <span class="other-routes-wrap">
                <span v-for="(route, routeIndex) in stopDetails.stop_routes" :key="routeIndex" class="other-routes">
                    <router-link :to="{
                        name: 'routeinfo',
                        params: {
                            id: route.routeid
                        }
                    }"
                    >{{ route.routec }}</router-link>
                </span>
            </span>
    </div>
    <div class="row">
      <h5 class="stop-menu-bottom-heading">
        轉乘優惠
      </h5>

      <!--<bbi-table :bbi_data="stop_menu_btm_data.bbi" :route_info="stop_menu_bottom.route_info"></bbi-table>-->

    </div>

    <!-- show less -->
    <div class="row">
      <div class="more-stop-details">
        <a
          v-if="!moreDetails"
          href='javascript:void(0)'
          @click="hideMoreDetails()"
        >更多...</a>
      </div>
    </div>
    <div class="clear"></div>
  </div>
</template>

<script>
import {mapMutations, mapState} from 'vuex';

export default {
  name: "StopMenuBottom",
  computed: {
    ...mapState('stopMenu', ['stopDetails', 'moreDetails'])
  },
  methods: {
    ...mapMutations('stopMenu', ['hideMoreDetails']),

  },
  mounted() {
  },
}
</script>

<style scoped>
.other-routes {
  color: blue;
}

.other-routes::after {
  content: ", ";
  margin-right: 2px;
}

.other-routes:last-child::after {
  content: "";
}

.stop-menu-bottom-heading {
  font-size: 20px;
}
</style>
